import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigErrorScreen, loadAppConfig } from '@platform/app-kit';
import { App } from './app.tsx';
import { createRuntime } from './bootstrap.ts';

const root = createRoot(document.getElementById('root') as HTMLElement);

// The edge serves /config.json per cell × env (docs/app-kit.md); vite dev defaults to mock.
void loadAppConfig({ app: 'admin', env: import.meta.env }).then((result) => {
  if (result.ok) {
    root.render(
      <StrictMode>
        <App runtime={createRuntime(result.config)} />
      </StrictMode>,
    );
  } else {
    root.render(
      <StrictMode>
        <ConfigErrorScreen problems={result.problems} />
      </StrictMode>,
    );
  }
});
